import { Pipe, PipeTransform } from '@angular/core';
import { ServiceTypeMetadataMap } from '@common/constants';

@Pipe({
  name: 'serviceTypeDisplayName',
  pure: true
})
export class ServiceTypeToDisplayNamePipe implements PipeTransform {
  transform(key: string, displayNameOverride?: string): string {
    return displayNameOverride ?? ServiceTypeMetadataMap[key]?.displayName ?? '';
  }
}
